import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';
import { AuthFacade } from 'src/app/store/auth/facade/auth.facade';
import { Observable, of } from 'rxjs';
import { Injectable } from "@angular/core";
import { Features } from "src/app/models/features";
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FeaturesFacade {
    public isFeatureEnabledForUser$(feature: Features): Observable<boolean> {
        return this.authFacade.isUserInvestor$.pipe(
            switchMap((isUserInvestor: boolean) => {
                return (isUserInvestor) ? of(this.featureToggleService.featureIndividualInvestorOn(feature)) : of(this.featureToggleService.featureOn(feature));
            })
        );
    }

    constructor(private authFacade: AuthFacade, private featureToggleService: FeatureToggleService) {}
}
